import React, { useEffect, useState } from "react";
import Logo from "assets/images/svg/click-for-marry02.svg";
import { Link, useLocation } from "react-router-dom";
import Button from "components/BaseWidgets/button";
import {
  CloseIcon,
  CrownIcon,
  HamburgerIcon,
  LogoutIconCircle,
  NavNotification,
} from "assets/icons";
import HeaderSearch from "./components/HeaderSearch";
import Notification from "./components/Notification";
import HederMenu from "./components/HederMenu";
import { links } from "./helper";
import ProfileDetails from "components/HomePage/components/ProfileDetails";
import LinkCard from "components/HomePage/components/LinkCard";
import { responsiveProfileData } from "./components/HederMenu/helper";
import ActionModal from "components/Settings/components/ActionModal";
import { useLogout } from "hooks/api/useAuth";
import { retrieveToken, storeToken } from "utils/storage";
import useMediaQuery from "hooks/useMediaQuery";
import { useProfileCompletion } from "hooks/api/useHome";
import { usePremium } from "context/PremiumContext";
import GoPremiumCard from "components/CustomWidgets/goPremiumCard";

function Header({ isLanding, setShowPremiumModal, showPremiumModal }) {
  const [scrolled, setScrolled] = useState(false);
  const [notification, setNotification] = useState(false);
  const location = useLocation();
  const [navActive, setNavActive] = useState(false);
  const [logoutModal, setLogoutModal] = useState(false);
  const { mutate: logout } = useLogout();
  const isMobile = useMediaQuery("(max-width: 991px)");
  const { data: userData, isLoading } = useProfileCompletion({
    enabled: !isLanding,
  });

  const { setIsPremium, isPremium } = usePremium();

  console.log(isPremium, "isPremium");

  // Check if current page is home
  const isHomePage = location.pathname === "/home";

  useEffect(() => {
    if (userData?.common_home_data?.is_premium_member !== undefined) {
      setIsPremium(userData.common_home_data.is_premium_member);
    }
    if (userData?.common_home_data?.onboarding_steps !== undefined) {
      storeToken(
        "onboarding_steps",
        userData?.common_home_data?.onboarding_steps
      );
    }
  }, [userData, setIsPremium]);

  const handleLogout = () => {
    const refreshToken = retrieveToken("refreshToken");
    const deviceId = retrieveToken("deviceId");

    logout({ refresh: refreshToken, device_id: deviceId });
  };

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 0;
      setScrolled(isScrolled);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setNavActive(false);
  }, [location.pathname]);

  return (
    <>
      {isLanding ? (
        <nav className={`landing-header-wrapper ${scrolled ? "scrolled" : ""}`}>
          <div className="header-container container">
            <div className="left-container">
              <Link to="/home" className="logo-container brand-logo">
                <img src={Logo} alt="logo" />
              </Link>
            </div>
            <div className="right-container">
              <span className="member-text">Already a member?</span>
              <div className="login-button-wrapper">
                <Button href={"/login"} className={"register-link"} size="sm">
                  Login
                </Button>
              </div>
            </div>
          </div>
        </nav>
      ) : (
        <nav className={`header-wrapper ${scrolled ? "scrolled" : ""}`}>
          <div className="container flex justify-between items-center gap-3">
            <div className="left-section">
              <Link to="/home" className="logo-container brand-logo">
                <img src={Logo} alt="logo" />
              </Link>
              <div className="action-wrapper">
                <div className="link-container">
                  {links.map((link, index) => {
                    // const isRestricted = !isPremium && link.to === "/connect";

                    return (
                      <Link
                        key={index}
                        to={link.to}
                        // onClick={(e) => {
                        //   if (isRestricted) {
                        //     e.preventDefault(); // 🚫 stop routing
                        //     setShowPremiumModal(true); // ✅ open modal
                        //   }
                        // }}
                        className={`link ${
                          location.pathname === link.to ? "active" : ""
                        }`}
                      >
                        {link.name}
                      </Link>
                    );
                  })}
                </div>
                <HeaderSearch />
              </div>
            </div>
            <div className="right-section flex items-center gap-5">
              <Button
                onClick={() => {
                  setNotification(true);
                }}
                height={24}
                variant="custom"
                className="notification-btn"
              >
                <NavNotification />
              </Button>
              <Button href="/plans" height={44} className="upgrade-btn">
                <CrownIcon />
                {isPremium ? "Premium User" : "Upgrade plan"}
              </Button>
              {!isMobile && <HederMenu setLogoutModal={setLogoutModal} />}
              <Button
                onClick={() => setNavActive(true)}
                className="hamburger-icon"
                variant="custom"
                height={24}
              >
                <HamburgerIcon />
              </Button>
            </div>
          </div>
          <div
            className={`res-menu-wrapper container ${navActive ? "active" : ""}`}
          >
            <div className="flex items-center justify-between gap-2 header">
              <Link to="/home" className="logo-container brand-logo">
                <img src={Logo} alt="logo" />
              </Link>
              <Button
                onClick={() => setNavActive(false)}
                variant="custom"
                height={24}
              >
                <CloseIcon />
              </Button>
            </div>
            <ProfileDetails
              profileData={userData?.common_home_data}
              isLoading={isLoading}
            />
            <LinkCard data={responsiveProfileData} setModal={setLogoutModal} />
          </div>
        </nav>
      )}
      {!isLanding && (
        <Notification open={notification} setOpen={setNotification} />
      )}
      <ActionModal
        title="Log out of your account?"
        description="You'll need to sign in again to continue."
        open={logoutModal}
        setOpen={setLogoutModal}
        footer={{
          left: { label: "Cancel", action: () => setLogoutModal(false) },
          right: { label: "Logout", action: () => handleLogout() },
        }}
        icon={<LogoutIconCircle />}
      />
    </>
  );
}

export default Header;
